
var extension = {} ;
extension.name = "noFormButton" ;

/**
 * called on view prepare
 */
extension.init = function(){
    var view = this ;
    view.on("render", function(){
        if(view.viewRootEl){
            var buttons = view.viewRootEl.querySelectorAll("button") ;
            for(var i=0; i<buttons.length; i++){
                if(!buttons[i].type || buttons[i].type === "submit"){
                    buttons[i].type = "button" ;
                }
            }
        }
    }) ;
    var forms = Array.prototype.slice.apply(view.viewRootEl.querySelectorAll("form")) ;
    if(view.viewRootEl.tagName === "FORM"){
        forms.push(view.viewRootEl) ;
    }
    for(var i=0; i<forms.length; i++){
        forms[i].onsubmit = function(){return false;};
    }
} ;

module.exports = extension ;